import { useProjects, useProjectDelete } from '@/hooks/useProjects';
import { ProjectCard } from '@/components/business/ProjectCard';
import { CreateProjectDialog } from '@/components/business/CreateProjectDialog';
import { Loader2, Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { useState } from 'react';

export function DashboardPage() {
  const { projects, isLoading } = useProjects();
  const { deleteProjectWithCascade } = useProjectDelete();
  const [search, setSearch] = useState('');

  const filteredProjects = projects.filter(p => 
    p.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">项目列表</h1>
          <p className="text-sm text-muted-foreground mt-1">
            管理你的小红书内容生成项目
          </p>
        </div>
        <CreateProjectDialog />
      </div>

      <div className="flex items-center gap-2 max-w-sm">
        <div className="relative flex-1">
          <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" />
          <Input
            placeholder="搜索项目..."
            className="pl-8 bg-white h-9 text-sm rounded-xl"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {isLoading ? (
        <div className="h-64 flex items-center justify-center">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
        </div>
      ) : filteredProjects.length === 0 ? (
        <div className="h-64 flex flex-col items-center justify-center border rounded-2xl border-dashed bg-muted/20">
          <p className="text-sm text-muted-foreground mb-4">暂无项目</p>
          <div className="flex gap-2">
            <CreateProjectDialog buttonText="立即创建第一个项目" />
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProjects.map((project) => (
            <ProjectCard 
              key={project.id} 
              project={project} 
              onDelete={deleteProjectWithCascade} 
            />
          ))}
        </div>
      )}
    </div>
  );
}

